<style scoped>
    @import url("../../../styles/smartControl/defAgent.scss");
</style>

<template>
    <div class="box_defAgent mt-2">

        <div class="painelGeral">

            <div class="" v-if="flagExibMsg" :style="{'color':'white'}">Atualização concluída.</div>

            <FormSC
            :nomeSys="this.nomeSys"
            :payloadSys="this.payloadSys"
            @upFromChild="callFather($event)"
            />

            <div v-if="flagExibMsg2"
            class="mt-4 mb-4"  
            :style="{'color':'white', 'align-self':'center'}">Nenhuma alteração detectada.</div>

        </div>

    </div>
</template>

<script>
import FormSC from './FormSC'

export default {

    props:['agent_unit'],

    components:{FormSC},

    data() {
        return {
            
            payloadSys:{},
            nomeSys:'',
            flagExibMsg:false,
            flagExibMsg2:false,
        }
    },

    methods:{

        deepEqual(a, b) {

            if (a === b) return true;
            if (typeof a !== "object" || typeof b !== "object" || a === null || b === null)
                return false;

            const ka = Object.keys(a);
            const kb = Object.keys(b);
            if (ka.length !== kb.length) return false;

            for (const k of ka) {
                if (!kb.includes(k)) return false;
                if (!this.deepEqual(a[k], b[k])) return false;
            }
            return true;
        },

        callFather(e) { // --> DefinicoesSC.vue (pai) | 08/01/2026
            //console.log('evento from child: ',e)
            // -- emitir evento para o pai atualizar, se houve alteração.
            const flagEqual = this.deepEqual(this.payloadSys, e)
            if (!flagEqual) { this.$emit('estruturaFromChild',e); this.flagExibMsg2 = false }
            else { this.flagExibMsg2 = true }
        },
        
        preForm() {

            this.nomeSys = this.$store.state.sistemaSC
            this.payloadSys = this.agent_unit['estrutura'] // rcv via props
            //console.log(this.payloadSys)
        },
    },

    created() {
        window.scrollTo(0,0)
        this.preForm()
    }
}
</script>